export default __webpack_public_path__ + "static/media/09_stromky-v-chranicich_rehounkovaLCR-min.923ec3cf.jpg";